module.exports = __webpack_public_path__ + "static/DifficultyDifficultGames2-3ae1e221b693babc5fa94591871597ba.png";